import { useEffect, useState } from 'react'
import { withLocalize } from 'react-localize-redux'
import { connect } from 'react-redux'

import FullScreenView from '../components/FullScreenView/FullScreenView'
import { getSystemByIdRaw } from 'common/selectors/systems'
import * as SystemUtils from 'utils/system'
import { getWeatherMeasures } from 'api/system'

const FullScreenSystem = props => {
  const { system, screen, hideModal, translate, user } = props
  const [weather, setWeather] = useState()
  const [loading, setLoading] = useState(true)
  const params = []
  for (let i = 0; i < Object.keys(screen.Meta).length; i++) {
    if (screen.Meta[Object.keys(screen.Meta)[i]]) {
      params.push(Object.keys(screen.Meta)[i])
    }
  }
  const handleClose = () => {
    hideModal()
  }

  const systemJS = system.toJS()
  const sortedData = SystemUtils.getDataSorted(systemJS)

  useEffect(() => {
    if (systemJS.baseStationLocation) {
      const fetchWeatherData = async () => {
        try {
          const res = await getWeatherMeasures(systemJS.baseStationLocation, {
            isPremium: false
          })
          let weatherItem = res['weatherData']['weather']
          if (!weatherItem || !weatherItem['Meta']) {
            setLoading(false)
            return
          }
          let transformedWeather = {
            temperature: weatherItem['Meta']['temp'],
            icon: weatherItem['Meta']['weather'][0]['icon'],
            description: weatherItem['Meta']['weather'][0]['description'],
            humidity: weatherItem['Meta']['humidity'],
            datetime: weatherItem['Datetime']
          }
          setWeather(transformedWeather)
        } catch (error) {
          setLoading(false)
        } finally {
          setLoading(false) // Ensure loading is stopped even if an error occurs
        }
      }

      fetchWeatherData()
    } else {
      setLoading(false)
    }
  }, [system])
  return (
    <FullScreenView
      user={user}
      system={systemJS}
      data={sortedData.filter(data => params.includes(data.type))}
      onClose={handleClose}
      translate={translate}
      screen={screen}
      weather={weather}
      loading={loading}
    />
  )
}

const mapStateToProps = (state, ownProps) => ({
  system: getSystemByIdRaw(ownProps.screen.DeviceId)(state)
})

const mapActionsToProps = {}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(FullScreenSystem))
